export default function createBarcodeListener(onScan, options = {}) {
  const config = {
    maxInterval: 130,
    minLength: 1,
    endKeys: ["Enter"],
    ...options
  };

  let buffer = "";
  let lastTime = 0;

  function handler(e) {
    // ignora combinações
    if (e.ctrlKey || e.altKey || e.metaKey) return;

    const now = performance.now();
    if (now - lastTime > config.maxInterval) {
      buffer = "";
    }
    lastTime = now;

    // Finalização do código
    if (config.endKeys.includes(e.key)) {
      if (buffer.length >= config.minLength) {
        onScan(buffer);
        e.preventDefault();
      }
      buffer = "";
      return;
    }

    // ✅ aceita SOMENTE números
    if (e.key >= "0" && e.key <= "9") {
      buffer += e.key;
    }
  }

  function start() {
    window.addEventListener("keydown", handler);
  }

  function stop() {
    window.removeEventListener("keydown", handler);
  }

  return { start, stop };
}
